<template></template>

<script>
  export default {
    name: 'PageTitle',
    props: ['title'],
    created() {
      document.title = this.title || 'KingsConference';
    },
    watch: {
      title() {
        document.title = this.title || 'KingsConference';
      }
    }
  };
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// page-title.vue?8f9a757e